<template>
    <div class="title-list-container">
        <!-- 搜索区域 -->
        <div class="search-bar">
            <el-input v-model="searchForm.title" placeholder="请输入标题" clearable size="large"
                style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
                <template #prefix>
                    <el-icon>
                        <Search />
                    </el-icon>
                </template>
            </el-input>

            <el-button type="primary" size="large" @click="handleSearch">
                <el-icon>
                    <Search />
                </el-icon>
                搜索
            </el-button>
        </div>

        <!-- 标题列表 -->
        <el-table :data="recordList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
            <el-table-column prop="title" label="主标题" width="250" />
            <el-table-column prop="subtitle" label="副标题" width="200" />
            <el-table-column prop="bottomContent" label="底部内容" width="200" />
            <el-table-column prop="subtitles" label="字幕" width="200" />
            <el-table-column prop="use_num" label="使用次数" width="120" />
            <el-table-column prop="prohibited_words" label="违禁词" width="150" />
            <el-table-column prop="status" label="状态" width="120">
                <template #default="{ row }">
                    <el-tag :type="row.status === 2 ? 'success' : 'warning'">
                        {{ row.status === 2 ? '正常' : '待审核' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="180" />

            <el-table-column label="操作" width="250" fixed="right">
                <template #default="scope">
                    <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
                        <el-icon>
                            <Edit />
                        </el-icon>
                        编辑
                    </el-button>
                    <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
                        <el-icon>
                            <Delete />
                        </el-icon>
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
            <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
                :total="pagination.total" :page-sizes="[10, 20, 30, 50]"
                layout="total, sizes, prev, pager, next, jumper" @size-change="fetchRecordList"
                @current-change="fetchRecordList" />
        </div>

        <!-- 新增/编辑对话框 -->
        <el-dialog v-model="dialogVisible" :title="dialogTitle" width="700px" :close-on-click-modal="false"
            :append-to-body="true" class="child-dialog">
            <el-form ref="recordForm" :model="recordForm" label-width="120px" :rules="formRules">
                <el-form-item label="主标题" prop="title">
                    <el-input v-model="recordForm.title" placeholder="请输入主标题" size="large" />
                </el-form-item>
                <el-form-item label="副标题">
                    <el-input v-model="recordForm.subtitle" placeholder="请输入副标题" size="large" />
                </el-form-item>
                <el-form-item label="底部内容">
                    <el-input v-model="recordForm.bottomContent" placeholder="请输入底部内容" size="large" />
                </el-form-item>
                <el-form-item label="字幕">
                    <el-input v-model="recordForm.subtitles" placeholder="请输入字幕内容" size="large" type="textarea"
                        :rows="3" />
                </el-form-item>
                <el-form-item label="违禁词">
                    <el-input v-model="recordForm.prohibited_words" placeholder="请输入违禁词，多个用逗号分隔" size="large" />
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="recordForm.status">
                        <el-radio :label="1">待审核</el-radio>
                        <el-radio :label="2">正常</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="使用次数">
                    <el-input-number v-model="recordForm.use_num" :min="0" size="large" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitRecordForm">确认</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import { Search, Edit, Delete } from '@element-plus/icons-vue'

export default {
    components: { Search, Edit, Delete },
    props: {
        titleId: { type: Number, required: true },
        storeId: { type: Number, required: true }
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            dialogTitle: '新增文案',
            isEditMode: false,
            searchForm: { title: '' },
            recordForm: {
                id: null, title: '', subtitle: '', bottomContent: '', subtitles: '',
                prohibited_words: '', status: 1, use_num: 0,
                wenan_id: this.titleId, store_id: this.storeId
            },
            formRules: {
                title: [{ required: true, message: '请输入主标题', trigger: 'blur' }],
                status: [{ required: true, message: '请选择状态', trigger: 'change' }]
            },
            recordList: [],
            pagination: { page: 1, pageSize: 10, total: 0 }
        }
    },
    mounted() { this.fetchRecordList(); },
    methods: {
        openAddDialog() {
            this.dialogTitle = '新增文案'; this.isEditMode = false;
            this.recordForm = { id: null, title: '', subtitle: '', bottomContent: '', subtitles: '', prohibited_words: '', status: 1, use_num: 0, wenan_id: this.titleId, store_id: this.storeId };
            this.dialogVisible = true;
        },
        openEditDialog(row) {
            this.dialogTitle = '编辑文案'; this.isEditMode = true;
            this.recordForm = { id: row.id, title: row.title, subtitle: row.subtitle || '', bottomContent: row.bottomContent || '', subtitles: row.subtitles || '', prohibited_words: row.prohibited_words || '', status: row.status, use_num: row.use_num, wenan_id: this.titleId, store_id: this.storeId };
            this.dialogVisible = true;
        },
        submitRecordForm() {
            this.$refs.recordForm.validate(async (valid) => {
                if (valid) {
                    try {
                        const action = this.isEditMode ? 'update' : 'add';
                        const { data } = await axios.post(`${config.BASE_URL}/shop/api/wenan_create_record.php`, { action, ...this.recordForm });
                        if (data.success) { this.$message.success(this.isEditMode ? '更新成功' : '添加成功'); this.dialogVisible = false; this.fetchRecordList(); }
                        else { this.$message.error(data.error || '操作失败'); }
                    } catch (error) { this.$message.error(`操作失败: ${error.response?.data?.error || error.message}`); console.error('表单提交错误:', error); }
                }
            });
        },
        async fetchRecordList() {
            this.loading = true;
            try {
                const params = { action: this.searchForm.title ? 'search' : 'list', store_id: this.storeId, wenan_id: this.titleId, page: this.pagination.page, page_size: this.pagination.pageSize };
                if (this.searchForm.title) params.title = this.searchForm.title;
                const { data } = await axios.post(`${config.BASE_URL}/shop/api/wenan_create_record.php`, params);
                if (data.data) { this.recordList = data.data; this.pagination.total = data.pagination?.total || data.data.length; }
            } catch (error) { this.$message.error('获取文案列表失败'); console.error('获取文案列表错误:', error); }
            finally { this.loading = false; }
        },
        handleSearch() { this.pagination.page = 1; this.fetchRecordList(); },
        async handleDelete(id) {
            this.$confirm('确定要删除该文案吗？', '警告', { confirmButtonText: '确认删除', cancelButtonText: '取消', type: 'warning' }).then(async () => {
                try {
                    const { data } = await axios.post(`${config.BASE_URL}/shop/api/wenan_create_record.php`, { action: 'delete', id: id, store_id: this.storeId });
                    if (data.success) { this.$message.success('删除成功'); this.fetchRecordList(); }
                    else { this.$message.error(data.error || '删除失败'); }
                } catch (error) { this.$message.error('删除失败'); console.error('删除错误:', error); }
            }).catch(() => { });
        }
    }
}
</script>

<style scoped>
.title-list-container {
    padding: 20px;
    background: transparent !important;
    color: #e0e0e0;
}

.search-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 20px;
    padding: 16px;
    background: rgba(18, 14, 33, 0.4) !important;
    backdrop-filter: blur(10px);
    border-radius: 12px;
    border: 1px solid rgba(157, 78, 221, 0.2);
}

.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

:deep(.el-table) {
    background-color: transparent !important;
}

:deep(.el-table__body-wrapper) {
    background-color: transparent !important;
}

:deep(.el-pagination) {
    --el-pagination-bg-color: transparent;
}

:deep(.el-pagination .btn-prev),
:deep(.el-pagination .btn-next),
:deep(.el-pagination .el-pager li) {
    background: rgba(157, 78, 221, 0.1) !important;
    border: 1px solid rgba(157, 78, 221, 0.3) !important;
    color: #a0a0c0 !important;
    border-radius: 8px;
}

:deep(.el-pagination .btn-prev:hover),
:deep(.el-pagination .btn-next:hover),
:deep(.el-pagination .el-pager li:hover) {
    background: rgba(157, 78, 221, 0.2) !important;
    color: #c084fc !important;
}

:deep(.el-pagination .el-pager li.active) {
    background: linear-gradient(135deg, #6546b4, #9d4edd) !important;
    color: #fff !important;
}

:deep(.el-pagination__total),
:deep(.el-pagination__jump) {
    color: #a0a0c0 !important;
}
</style>